import TooltipComp, {
  Props as TooltipProps,
} from '../../general/tooltip-comp/tooltip-comp';

import styles from './download-audio-file.module.scss';
import Download from '../../general/icon/components/download';

type DownloadAudioFileProps = {
  url: string;
  title: string;
  tooltipTheme?: TooltipProps['theme'];
};

const Content = () => (
  <div className={styles['download-audio-file__content']}>
    {polyglot.t('employee_assistance.download.download_audio_file')}
  </div>
);

const DownloadAudioFile = ({
  url,
  title,
  tooltipTheme = 'blue',
}: DownloadAudioFileProps) => (
  <div className={styles['download-audio-file']}>
    <div className={styles['download-audio-file__tooltip']}>
      <TooltipComp
        theme={tooltipTheme}
        showTooltip
        position='left'
        content={<Content />}
      />
    </div>

    <a
      href={url}
      rel='noopener noreferrer'
      className={styles['download-audio-file__icon']}
      target='_blank'
      download={title}
      aria-label={polyglot.t(
        'employee_assistance.download.download_audio_file_name',
        { fileName: title },
      )}
    >
      <Download />
    </a>
  </div>
);

DownloadAudioFile.displayName = 'DownloadAudioFile';

export default DownloadAudioFile;
